import ArticleFontWrapper from './write/ArticleFontWrapper';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ArticleVersionPreview(props) {
  const {
    version
  } = props;
  if (!version) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: "center",
    blockSize: "100%",
    inlineSize: "100%",
    overflow: "auto",
    children: /*#__PURE__*/_jsx(ArticleFontWrapper
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    , {
      templateSettings: props.templateSettings,
      linksColor: props.linksColor,
      children: /*#__PURE__*/_jsxs(View, {
        marginBlockStart: "400",
        inlineSize: "688px",
        children: [/*#__PURE__*/_jsx("div", {
          className: "article-title-text m-bottom-4",
          children: version.object.name
        }), /*#__PURE__*/_jsx("div", {
          className: "article-subtitle-text m-bottom-8",
          children: version.object.articleSummary
        }), /*#__PURE__*/_jsx("div", {
          className: "article-body",
          children: /*#__PURE__*/_jsx("div", {
            dangerouslySetInnerHTML: {
              __html: version.object.articleBody
            }
          })
        })]
      })
    })
  });
}